import React from 'react';

import HeaderButton from 'components/DetailsComponents/HeaderButton';

import { useHistory } from 'react-router-dom';
import { usePicklistPermissions } from 'hooks/Picklist';

import { PICKLIST_SUMMARY_PATH } from 'constants/routeConstants';

import DeleteIcon from '@material-ui/icons/Delete';
import CreateIcon from '@material-ui/icons/Create';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';

export const MobileHeaderButtons = ({ onEdit, onRemove }) => {
  const history = useHistory();

  const { canEdit, canRemove } = usePicklistPermissions();

  const goBack = () => history.push(PICKLIST_SUMMARY_PATH);

  return (
    <>
      {canEdit && (
        <HeaderButton onClick={onEdit}>
          <CreateIcon />
        </HeaderButton>
      )}
      {canRemove && (
        <HeaderButton onClick={onRemove}>
          <DeleteIcon />
        </HeaderButton>
      )}
      <HeaderButton onClick={goBack}>
        <ChevronLeftIcon />
      </HeaderButton>
    </>
  );
};
